import { Box, TextNew } from '@jfs/ui-new'
import { isEmpty, Passwordreg } from '@jfs/utils'
import { FC, useEffect } from 'react'
import { Checkbox, CheckBoxTypes } from '../../comps/Checkbox'
import { ModBox } from '../../comps/ModifiedBox/ModifiedBox'
import { forgotPwdStrings } from '../../data/static/strings'
import { Colors } from '../../util/util'
import { pwdStrengthCbData } from './FormData'

const checkForSequenceDigit = (value: string) => {
  const allSeqNumsArr = ['0123', '1234', '2345', '3456', '4567', '5678', '6789']
  return allSeqNumsArr.some((element) => value.includes(element))
}

const checkForBlankSpace = (value: string) => {
  const blankSpace = ' '
  return value.includes(blankSpace)
}

export const isActive = (text: string) => {
  const checkedData: any = []
  if (text.length >= 8) {
    checkedData.push('1')
  }
  if (checkedData.includes('2')) {
    checkedData.filter((item: any) => item !== '2')
  }
  if (text.toUpperCase() !== text) {
    checkedData.push('2')
  }
  if (forgotPwdStrings.capitalLettersRegex.test(text)) {
    checkedData.push('3')
  }
  if (forgotPwdStrings.oneSpecialCharRegex.test(text)) {
    checkedData.push('4')
  }
  if (forgotPwdStrings.oneDigitRegex.test(text)) {
    checkedData.push('5')
  }
  if (!checkForSequenceDigit(text)) {
    checkedData.push('6')
  }
  if (!forgotPwdStrings.repeatingDigitRegex.test(text)) {
    checkedData.push('7')
  }
  if (!checkForBlankSpace(text)) {
    checkedData.push('8')
  }
  return checkedData
}

interface CheckListProps {
  showPwdCheckView?: boolean
  checkedData?: any
}
const CheckList: FC<CheckListProps> = ({ allValues, setFieldValue, fieldName }: any) => {
  const text = allValues?.password
  const confPassword = allValues?.passwordConfirm
  const preDefFunc = isActive(text)
  const isPasswordRegexSatisfied = Passwordreg.test(text)

  useEffect(() => {
    if (setFieldValue && fieldName) {
      setFieldValue(fieldName, preDefFunc)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allValues?.password, allValues?.passwordConfirm])

  if (
    confPassword?.length > 0 &&
    isPasswordRegexSatisfied &&
    text === confPassword &&
    preDefFunc?.length > pwdStrengthCbData.length - 1
  ) {
    return null
  } else {
    return (
      <ModBox show={text?.length > 0} width={'100%'}>
        <TextNew type={'body12'} fontWeight="MEDIUM" color={'PRIMARY_GREY'}>
          {forgotPwdStrings.pwdMustHaveAtleast}
        </TextNew>
        <Box flexDirection="row" flexWrap="wrap" justify="space-between">
          {pwdStrengthCbData.map((data) => {
            return (
              <Box width={'50%'}>
                <Checkbox
                  isChecked
                  showCompleteText={true}
                  disabled={false}
                  type={CheckBoxTypes.CHECK_LIST}
                  size={20}
                  // Todo
                  color={preDefFunc.includes(String(data.id)) ? '#4FAF49' : Colors.DISABLED_GREY}
                  textColor={Colors.PRIMARY_GREY}
                  title={data.value}
                />
              </Box>
            )
          })}
        </Box>
      </ModBox>
    )
  }
}

export { CheckList }
